module.exports = __webpack_public_path__ + "static/a-xx-113-art-590534774749a47d8bcfd10d38e05d3e.jpg";